import * as Scrivito from "scrivito";
import React from "react";
import { useBeforeUnload } from "hooks/useBeforeUnload";
import { useSyncProject } from "hooks/projectHooks";

const Component = React.memo(() => {
  useSyncProject();
  useBeforeUnload();
  return <></>;
});

export const CallHooks = Scrivito.connect(() => <Component />);
